import React from 'react';
import * as S from './DesktopFilters.styles';
import { DesktopFilterSelectOptionProps } from './DesktopFilterSelectOption.types';
import { getDesktopFilterSelectOptionHref } from './DesktopFilterSelectOption.helpers';

export const DesktopFilterSelectOption = ({
  dataTestId,
  label,
  hrefParams,
  isSelected,
  onClick,
}: DesktopFilterSelectOptionProps) => {
  return (
    <S.LinkOption
      key={label}
      dataTestId={dataTestId}
      href={getDesktopFilterSelectOptionHref(hrefParams)}
      $isActive={isSelected}
      onClick={onClick}
    >
      <S.RadioButton $isActive={isSelected} />
      <S.LinkOptionText>{label}</S.LinkOptionText>
    </S.LinkOption>
  );
};
